export const ERROR_TYPES = {
  MIN: 'min',
  MAX: 'max',
};
